module.exports = __webpack_public_path__ + "static/media/licencja.f46a7620.jpg";